import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy
} from "@angular/core";
import { ChartService } from "../../services/chart.service";
import { AuthService } from "../../services";
import { LoaderService } from "../../services/loader.service";
import { UserService } from "../../services/user.service";
import { ToastService } from "../../services/toast.service";
import { UserUpdateModel } from "../../models/userUpdateModel";

import { trackByIndex } from "src/app/shared/utils/track-by.util";
@Component({
  standalone: false,
    selector: "app-workforce-info",
    templateUrl: "./workforce-info.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./workforce-info.component.scss"],
})
export class WorkforceInfoComponent
    implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
    @Input()
    selectedWorkforceData: any;
    @Output() successCallback = new EventEmitter<boolean>();

    showEditWorkforcePopup: boolean;
    showinfo: boolean;
    userUpdateModel: UserUpdateModel;
    showAddDevicePopUp: boolean;
    workForceInfoView: string;
    userWorkforceStats: any;

    constructor(
        private loaderService: LoaderService,
        private userService: UserService,
        private toastService: ToastService,
        private chartService: ChartService,
        private authService: AuthService,
        private zone: NgZone,
        private cd: ChangeDetectorRef,
    ) {
        this.workForceInfoView = "user_info";
    }

    ngOnInit(): void {
        this.cd.detectChanges();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.cd.detectChanges();
    }

    ngAfterViewInit() {
        this.initializeChart();
    }


    initializeChart() {
        this.showAddDevicePopUp = false;
        this.workForceInfoView = "user_info";
        this.zone.runOutsideAngular(() => {
            setTimeout(async () => {
                await this.chartService.setGaugeChart("gaugeChart1", 0);
                await this.chartService.setGaugeChart("gaugeChart2", 0);
            }, 1000);
        });
        this.cd.detectChanges();
    }

    editWorkForceProfile() {
        this.showEditWorkforcePopup = true;
        this.userUpdateModel = new UserUpdateModel();
        if (this.selectedWorkforceData) {
            this.userUpdateModel.fullName = this.selectedWorkforceData.fullName;
            this.userUpdateModel.securityProfileId =
                this.selectedWorkforceData.securityProfileId;
            this.userUpdateModel.id = this.selectedWorkforceData.id;
            this.userUpdateModel.userName = this.selectedWorkforceData.userName;
        }
    }

    ngOnDestroy(): void {}

    updateUserProfile() {
        this.loaderService.show();
        this.userService.update(this.userUpdateModel).subscribe(
            (result) => {
                this.showEditWorkforcePopup = false;
                this.toastService.showSuccess("User saved successfully!", true);
                this.loaderService.hide();
                this.successCallback.emit(true);
            },
            (error) => {
                this.toastService.showError(error, "Error updating profile!");
                this.loaderService.hide();
            },
        );
    }

    deleteUser() {
        this.loaderService.show();
        this.userService.delete(this.userUpdateModel.id).subscribe(
            (result) => {
                this.showEditWorkforcePopup = false;
                this.toastService.showSuccess(
                    "User deleted successfully!",
                    true,
                );
                this.loaderService.hide();
                this.successCallback.emit(true);
            },
            (error) => {
                this.toastService.showError(error, "Error deleting user!");
                this.loaderService.hide();
            },
        );
    }

    public trackByIndex = trackByIndex;
}
